
import { defineComponent } from "vue";
import TierModel from "../model/Tiers";
import Tier from "./Tier.vue";
import List from "./List.vue";

export default defineComponent({
  name: "TierList",
  components: { Tier, List },
  props: {
    tiers: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    getTierName: function (idx: number): string {
      return TierModel.getName(idx, this.tiers.length);
    },
    getTierImage: function (idx: number): string {
      return TierModel.getImage(idx, this.tiers.length);
    },
    tierChanged(tier, index) {
      this.$emit("changed", index, tier);
    },
  },
});
